import { CircularProgress } from '@material-ui/core';
import PictureAsPdfOutlinedIcon from '@material-ui/icons/PictureAsPdf';
import React, { useEffect, useState } from 'react';
import { useGlobalState } from 'store/reducers/reducer';
import { getSubscriptInvoices } from 'store/sagas/sagas';
import './manage-subscription.css';
import { longFormatDate } from 'utils/longFormatDate';
// filter 'draft' prefixed invoices from being displayed
const EXCLUDED_INVOICE_PREFIXES = ['draft'];
export const InvoiceList = () => {
    const { asyncDispatch } = useGlobalState();
    const [loading, setLoading] = useState(false);
    const [invoices, setInvoices] = useState();
    useEffect(() => {
        setLoading(true);
        asyncDispatch(getSubscriptInvoices())
            .then(setInvoices, console.error)
            .finally(() => {
            setLoading(false);
        });
    }, []);
    return (React.createElement("div", null,
        React.createElement("h1", null, "Invoices"),
        React.createElement("div", null, loading ? (React.createElement(CircularProgress, { size: "1.2rem", style: { color: '#290e88' } })) : invoices ? (React.createElement("div", { className: "billing__container" },
            React.createElement("div", { className: "billing__container-head" },
                React.createElement("span", null, "Number"),
                React.createElement("span", null, "Total"),
                React.createElement("span", null, "Created"),
                React.createElement("span", null, "View/Pay Invoice"),
                React.createElement("span", null, "Download PDF")),
            React.createElement("div", { className: "billing__container-body" }, invoices
                .filter((invoice) => !EXCLUDED_INVOICE_PREFIXES.some((term) => invoice.invoice_number
                .toLowerCase()
                .startsWith(term.toLowerCase())))
                .map((i) => {
                const dollars = i.amount;
                return (React.createElement("div", { key: i.id },
                    React.createElement("span", null, i.invoice_number),
                    React.createElement("span", null, dollars.toLocaleString('en-US', {
                        style: 'currency',
                        currency: 'USD'
                    })),
                    React.createElement("span", null, longFormatDate(new Date(i.date))),
                    React.createElement("a", { href: i.invoice_payment_link },
                        React.createElement("span", null, "View/Pay Invoice")),
                    i.invoice_pdf_link && (React.createElement("a", { href: i.invoice_pdf_link },
                        React.createElement(PictureAsPdfOutlinedIcon, { style: { color: '#4122af' } })))));
            })))) : (React.createElement("div", null, "Your account does not currently have any past or outstanding invoices")))));
};
